import { useQuery } from "@tanstack/react-query";

import { supabase } from "~/store/initializeStore";

export type SimulatorTarget = {
  id: string;
  userId: string | null;
  email: string;
  firstName: string | null;
  lastName: string | null;
  activeMealsPlanId: string | null;
  activeTrainingProgramId: string | null;
};

/**
 * Symulator otwiera się i z profilu podopiecznej, i z tabel wyzwania, gdzie w storze siedzi
 * zupełnie inna (albo żadna) klientka. Dlatego dane celu czytamy zawsze po `traineeId`,
 * zamiast opierać się na `store.trainee.profile`.
 */
export const useSimulatorTarget = (traineeId: string, enabled: boolean) =>
  useQuery({
    queryKey: ["simulator", "target", traineeId],
    enabled: enabled && Boolean(traineeId),
    queryFn: async (): Promise<SimulatorTarget> => {
      const { data, error } = await supabase
        .from("trainee")
        .select("id, userId, email, firstName, lastName, activeMealsPlanId, activeTrainingProgramId")
        .eq("id", traineeId)
        .single();

      if (error) {
        throw new Error(error.message);
      }

      return data as SimulatorTarget;
    },
  });
